import { MicroShortCard } from '@/shared/api-generated-types'
import * as styles from './style'

export interface Props extends Partial<MicroShortCard> {
  className?: string
}

const VideoShort = ({ className, link }: Props): JSX.Element | null => {
  if (!link) return null

  return (
    <span className={`${styles.root} ${className}`}>
      <iframe
        className={styles.videoContainer}
        title="Embedded YouTube Short"
        src={link}
        height="100%"
        width="100%"
        allow="autoplay"
        frameBorder="none"
      />
    </span>
  )
}

export default VideoShort
